// extracted by mini-css-extract-plugin
module.exports = {"textWrapperSearch":"Home_textWrapperSearch_1uPYg","textWrapperSearchMobile":"Home_textWrapperSearchMobile_2KNYE"};